import { useLocation } from "react-router-dom";

export function useIsSupportPage() {
  const { pathname } = useLocation();

  return pathname.startsWith("/support");
}

export default useIsSupportPage;

